module.exports = __webpack_public_path__ + "img/download_star_more@2x.e1f4712c.png";